<template>
  <div class="full-page-width relative locations p-b-40">
    <ConfirmationBar
      :showSavebar="showSavebar"
      @confirm="changeAccountData"
      @cancel="cancel"
    />
    <div class="row">
      <div class="flex-center m-b-40">
        <div class="flex-center">
          <Btn
            @click.native="routeIt"
            class="light bordered empty d-inline-block m-r-15 fix-40"
            :icon="{
              name: 'arrowLeftBig',
              size: '20',
            }" />
          <p class="user-name">{{ accountData.shipping_agent_name }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('agreements-view-general-info-text')"
          :title="$t('general')"
          :btnText="$t('Delete agreement')"
          btnType="red"
          btnIcon="deleteForever"
          @action="deleteAgreement"/>
      </div>
      <div class="col-xs-8">
        <div class="card">
          <InputSelect
            v-if="get_user.is_admin"
            class="m-b-20"
            :multiSelect=true
            :preselected="accountData.accessible_for_subaccounts"
            :label="$t('accessible_for_accounts')"
            @change="selectAccessibleSubaccount"
            :options="getAllowedSubaccounts" />
          <InputText
            :label="$t('account_name')"
            v-model="accountData.account_name"
            class="m-b-20"/>
          <CountrySelect
            :noContinent="true"
            :multiSelect="true"
            :valueKey="'alpha2'"
            :hint="'leave_countries_empty_hint'"
            :label="'allowed_countries'"
            :preselected="accountData.countries"
            @change="selectCountries"
            :rules="{required: false}"
            class="m-b-30" />
          <div class="toggle-card m-b-30">
            <div>
              <span class="title">{{ $t('status') }}</span>
              <span class="additional-info">{{ `${$t('enable')} ${$t('agreement')}` }}</span>
            </div>
            <Toggle id="activeAccountData"
              v-model="accountData.is_active" />
          </div>
          <div class="toggle-card">
            <div>
              <span class="title">{{ $t('customs_file') }}</span>
              <span class="additional-info">{{ $t('send_customs_invoice_to_carrier') }}</span>
            </div>
            <Toggle id="shouldSendCustomsFile"
                    v-model="accountData.should_send_customs_file" />
          </div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('agreements-view-products-info-text')"
          :title="$t('products')"
          :btnText="$t('add_product')"
          :showBtn="haveShippingProductsForAdding"
          @action="addProduct" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <div
            class="list-table-item padded"
            v-for="(item, index) in get_carrier_account_products" :key="`item-${index}`"
            @click="toggleNotePopup(item.id)">
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.shipping_product_name}` }} {{ `(${item.shipping_product_id})`  }}
              </span>
                <span class="additional-info" style="padding-bottom: 10px;">
                  {{ $t(item.delivery_type_name) }}
                </span>
                <span v-if="item.note"  style="padding: 4px; margin-bottom: 4px; font-size: 13px; margin-top: 5px; border-radius: 4px; background: #000; color: #fff" >
                  <Icon class="icon" fill-color="#fff" style="color: #fff; position:relative; top: 1px; display: inline-block" name="info" size="12" />
                  {{ $t(item.note) }}
                </span>
            </p>
            </div>
            <div @click.stop>
              <Btn
                class="button red"
                :icon="{
                name: 'deleteForever',
                size: '18',
              }"
                :btnText="$t('delete')"
                @btnClick="deleteProduct(item.id)"/>
            </div>
          </div>
        </ul>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row" v-if="barcodeViewHelper.length > 0">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('agreements-view-barcodes-info-text')"
          :title="$t('Barcodes')" />
      </div>
      <div class="col-xs-8">
        <div>
          <ul class="list-table">
          <li
            class="list-table-item padded"
            v-for="(item, index) in barcodeViewHelper" :key="`item-${index}`">
            <div class="table-cell">
              <p>
                <span class="d-block main-info m-b-20">
                  {{ $t(item.title) }}
                </span>
                <span class="d-block additional-info m-b-10">
                  {{ getBarcodeValue(`${item.prefix}_min`) + ' - ' + getBarcodeValue(`${item.prefix}_max`) }}
                </span>
                <span class="d-block additional-info" style="text-decoration: line-through;">
                  {{ getBarcodeValue(`${item.prefix}_last_min`) + ' - ' + getBarcodeValue(`${item.prefix}_last_max`) }}
                </span>
              </p>
            </div>
            <Btn
              class="button brand"
              :icon="{
                name: 'pen',
                size: '18',
              }"
              :btnText="$t('edit')"
              @btnClick="editBarcode([
                {
                  key: `${item.prefix}_min`,
                  value: accountData.barcode_json[0].params[`${item.prefix}_min`]
                },
                {
                  key: `${item.prefix}_max`,
                  value: accountData.barcode_json[0].params[`${item.prefix}_max`]
                },
                {
                  key: `${item.prefix}_last_min`,
                },
                {
                  key: `${item.prefix}_last_max`,
                },
              ])"/>
          </li>
        </ul>
        </div>
      </div>
    </div>
    <div class="separator" v-if="barcodeViewHelper.length > 0"></div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('agreements-view-integrations-info-text')"
          :title="$t('integrations')"
          :btnText="$t('add_consignor')"
          :showBtn="parseInt(this.accountData.integration_id) === 18"
          @action="addConsignor"/>
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            class="list-table-item padded"
            v-for="(item, index) in consignors" :key="`item-${index}`">
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.text}` }}
              </span>
                <span class="additional-info">
                 Consignor id: {{ $t(item.value) }}
                </span>
              </p>
            </div>
            <Btn
              class="button red"
              :icon="{
                name: 'deleteForever',
                size: '18',
              }"
              :btnText="$t('delete')"
              @btnClick="deleteConsignor(item.consignors_id)"/>
          </li>
        </ul>
        <div class="card">
          <div v-for="(param, key) in accountData.integration_params_fields[0]['login_params']" :key="`param-${key}`">
            <InputSelect
              v-if="param === 'CountryCode'"
              class="m-b-30"
              :label="$t('agreement_country')"
              v-model="accountData.login_parameters_json[0].params[param]"
              :options="[{value: 'DK', text: $t('Denmark')}, {value: 'SE', text: $t('Sweden')}, {value: 'FI', text: $t('Finland')}, {value: 'NO', text: $t('Norway')}]"
              :rules="{required: true}" />
            <InputText
              v-else
              :class="'m-b-30'"
              :label="param"
              v-model="accountData.login_parameters_json[0].params[param]"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="showFedExSection">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('fedex_csp_registration_info_text')"
          :title="$t('fedex_csp_registration')"
          :btnText="$t('register_fedex_account')"
          :btnIcon="'vpn_key'"
          @action="openFedExWizard" />
      </div>
      <div class="col-xs-8 card">
        <div class="p-20">
          <p v-if="accountData.login_parameters_json[0].params.ChildKey">
            <span class="main-info">FedEx Account: {{ accountData.login_parameters_json[0].params.ShippingAccount }}</span><br>
            <span class="additional-info text-success">✅ {{ $t('account_registered') }} (ChildKey: {{ accountData.login_parameters_json[0].params.ChildKey.substring(0, 8) }}...)</span>
          </p>
          <p v-else class="text-warning">
            ⚠️ {{ $t('account_not_registered_warning') }}
          </p>
        </div>
      </div>
    </div>
    <div class="separator" v-if="isDanskeFragtmend"></div>
    <div class="row" v-if="isDanskeFragtmend">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('danske_mapping_info_text')"
          :title="$t('product_mapping')"
          :btnText="$t('get_new_configuration')"
          :btnIcon="'restore'"
          @action="getDanskeConfiguration" />
      </div>
      <div class="col-xs-8 card">
        <div class="col-xs-12 m-b-20">
          <div class="col-xs-3">{{ $t('code') }}</div>
          <div class="col-xs-3">{{ $t('types') }}</div>
          <div class="col-xs-3">{{ $t('packaging') }}</div>
          <div class="col-xs-3">{{ $t('shipping_products') }}</div>
        </div>
        <div v-for="(item, index) in danskeCodes" :key="`code-${index}`">
          <div class="col-xs-12">
            <div class="col-xs-3">
              <InputText
                class="m-b-20"
                v-model="danskeCodes[index].code_text"
                disabled
                :rules="{required: true}"
              />
            </div>
            <div class="relative col-xs-3">
              <InputSelect
                class="m-b-20"
                :preselected=selectedDanskeTypes[index]
                :multiSelect=true
                :options="get_account_danske_code_types"
                :rules="{required: true}"
                @change="selectDanskeType($event, index, 'types')"
              />
            </div>
            <div class="relative col-xs-3">
              <InputSelect
                class="m-b-20"
                :options="packagingOptions"
                v-model="danskeCodes[index].packaging_id"
                @change="updateDanskeCode($event, index, 'packaging_id')"
              />
            </div>
            <div class="relative col-xs-3">
              <InputSelect
                class="m-b-20"
                :options="unfilteredShippingProducts"
                v-model="danskeCodes[index].shipping_product_id"
                @change="updateDanskeCode($event, index, 'shipping_product_id')"
                :rules="{required: true}"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Popup
      v-if="fedexWizard.open"
      :popupSmall=true
      minHeight="500px"
      @cancel="fedexWizard.open = false"
      :showConfirm="false">
      <template v-slot:header>
        <h2>{{ $t('FedEx CSP Registration') }} - {{ $t('Step') }} {{ fedexWizard.step }}</h2>
      </template>
      <div v-if="fedexWizard.step === 1">
        <InputText class="m-b-20" :label="$t('Account Number') + '*'" v-model="fedexWizard.data.accountNumber.value" />
        <InputText class="m-b-20" :label="$t('customer_name') + '*'" v-model="fedexWizard.data.customerName" />
        <InputText class="m-b-10" :label="$t('Street') + '*'" v-model="fedexWizard.data.address.streetLines[0]" />
        <div class="row m-b-10">
          <div class="col-xs-6"><InputText :label="$t('City') + '*'" v-model="fedexWizard.data.address.city" /></div>
          <div class="col-xs-6"><InputText :label="$t('Postal Code') + '*'" v-model="fedexWizard.data.address.postalCode" /></div>
        </div>
        <div class="row m-b-20">
          <div class="col-xs-6"><InputText :label="$t('State/Province Code')" v-model="fedexWizard.data.address.stateOrProvinceCode" /></div>
          <div class="col-xs-6">
            <InputSelect
              :label="$t('country') + '*'"
              v-model="fedexWizard.data.address.countryCode"
              :options="countriesOptions"
              :rules="{required: true}"
            />
          </div>
        </div>
        <div class="text-right">
          <Btn class="button blue" :btnText="$t('validate_address')" @btnClick="validateFedExAddress" :loading="fedexWizard.loading" />
        </div>
      </div>
      <div v-if="fedexWizard.step === 2">
        <InputText class="m-b-10" :label="$t('Invoice Number') + '*'" v-model="fedexWizard.invoice.number" />
        <InputText class="m-b-10" :label="$t('Invoice Date (YYYY-MM-DD)') + '*'" v-model="fedexWizard.invoice.date" />
        <InputText class="m-b-10" :label="$t('Invoice Amount') + '*'" v-model="fedexWizard.invoice.amount" />
        <InputText class="m-b-20" :label="$t('Currency') + '*'" v-model="fedexWizard.invoice.currency" />
        <div class="text-right">
          <Btn :btnText="$t('back')" class="button gray m-r-10" @btnClick="fedexWizard.step = 1" />
          <Btn class="button blue" :btnText="$t('validate_invoice')" @btnClick="validateFedExInvoice" :loading="fedexWizard.loading" />
        </div>
      </div>
      <div v-if="fedexWizard.step === 3">
        <div class="text-center p-20">
          <Icon name="check_circle" size="48" fill-color="#28a745" style="color: #28a745" /><br>
          <h3>{{ $t('registration_successful') }}</h3>
          <p class="m-b-20">{{ $t('child_keys_retrieved') }}</p>
          <Btn class="button blue" :btnText="$t('finish')" @btnClick="fedexWizard.open = false" />
        </div>
      </div>
    </Popup>
    <Popup
      v-if="openNotePopup"
      :popupSmall=true
      minHeight="400px"
      @cancel="toggleNotePopup"
      @confirm="submitNoteForm">
      <template v-slot:header>
        <h2>{{ $t('Edit note') }}</h2>
      </template>
      <div class="row">
        <InputText
          :label="$t('input_note')"
          v-model="noteForm.note"/>
      </div>
    </Popup>
    <Popup
      v-if="openPopup"
      :popupSmall=true
      minHeight="400px"
      @cancel="togglePopup"
      @confirm="submitForm">
      <template v-slot:header>
        <h2 v-if="addProductPopup">{{ $t('add_product') }}</h2>
        <h2 v-if="editBarcodesPopup">{{ $t('Edit barcodes') }}</h2>
      </template>
      <div v-if="addProductPopup">
        <div >
          <InputSelect
            :multiSelect=true
            class="m-b-20"
            :label="$t('Select product')"
            :preselected="selectedProducts"
            @change="selectShippingProduct"
            :options="shippingProducts"
          />
        </div>
      </div>
      <div v-if="editBarcodesPopup">
        <div>
          <InputText
            class="m-b-40"
            :label="activeMin"
            v-model="minValue"/>
          <InputText
            class="m-b-40"
            :label="activeMax"
            v-model="maxValue"/>
        </div>
      </div>
    </Popup>
    <Popup
      v-if="openConsignorPopup"
      :popupSmall=true
      minHeight="400px"
      @cancel="toggleConsignorPopup"
      @confirm="submitConsignorForm">
      <template v-slot:header>
        <h2 v-if="addConsignorPopup">{{ $t('add_consignor') }}</h2>
      </template>
      <div v-if="addConsignorPopup">
        <div>
          <InputSelect
            :label="$t('apply_for_shipper')"
            v-model="consignorForm.senderId"
            :options="shippers"
            :rules="{required: true}" />
          <div>
            <InputText
              class="m-b-20"
              :label="$t('consignor_id')"
              v-model="consignorForm.consignorId"
              :rules="{required: true}"
            />
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import ConfirmationBar from '@/components/global/confirmationBar';
import CountrySelect from '@/components/elements/inputs/countrySelect.vue';

import InfoTextBox from '@/components/global/infoTextBox';

export default {
  name: 'agreementsView',
  components: {
    Btn,
    Popup,
    InputText,
    Toggle,
    InputSelect,
    InfoTextBox,
    ConfirmationBar,
    CountrySelect
  },
  data() {
    return {
      openPopup: false,
      openConsignorPopup: false,
      addProductPopup: false,
      addConsignorPopup: false,
      editBarcodesPopup: false,
      fedexWizard: {
        open: false,
        loading: false,
        step: 1,
        accountAuthToken: null,
        authOptions: [],
        pinOption: 'SMS',
        pin: '',
        countries: [],
        data: {
          accountNumber: { value: '' },
          address: {
            streetLines: [''],
            city: '',
            stateOrProvinceCode: '',
            postalCode: '',
            countryCode: '',
            residential: true
          },
          customerName: ''
        },
        invoice: {
          number: '',
          date: '',
          amount: '',
          currency: 'USD'
        }
      },
      openNotePopup: false,
      accountId: '',
      editNoteId: '',
      selectedDanskeTypes: {},
      danskeCodes: {},
      packagingOptions: [],
      noteForm: {
        shipping_product_id: '',
        admin_carrier_account_id: '',
        note: ''
      },
      accountData: {
        integration_name: '',
        shipping_agent_id: '',
        account_name: '',
        login_parameters_json: [{
          params: {},
          integration_id: '',
        }],
        barcode_json: {
          integration_id: '',
          params: {},
        },
        countries: [],
        accessible_for_subaccounts: [],
        is_active: '',
        integration_type: '',
        integration_id: '',
        backoffice_id: '',
        should_create_sales_orders: '',
        should_send_customs_file: '',
        have_proactive_support: '',
        company_id: '',
        display_account_name: '',
        shipping_agent_name: '',
        integration_params_fields: [{
          login_params: []
        }]
      },
      accountConsignor: {
        item: [],
        count: '',
        entity: {},
      },
      barcodeViewHelper: [],
      // ADD shipping products
      shippingProducts: [],
      unfilteredShippingProducts: [],
      selectedProducts: [],
      // ADD Consignor
      consignorForm: {
      senderId: '',
      selectedLocations: [],
      consignorId: '',
      },
      shippers: [],
      consignors: [],
      // edit barcodes
      activeMin: '',
      activeMax: '',
      activeLastMin: '',
      activeLastMax: '',
      maxValue: '',
      minValue: '',
      // Savebar data
      showSavebar: false,
      savebarEnabled: false,
    };
  },
  async created() {
    this.accountId = this.$route.params.id ? this.$route.params.id : localStorage.accountId
    //this.fetchCountries();
    await this.getCarrierAccountAndSetData();
    await this.getCarrierAccountProducts();
    await this.getShippingProducts();
    await this.getConsignnes();
    await this.$store.dispatch("GET_SHIPPERS").then((res) => {
      this.shippers = [
        ...res.map((opt) => {
          return {
            value: opt.id,
            text: `
                ${opt.company_name ? opt.company_name + ', ' : ''}
                ${opt.name ? opt.name + ', ' : ''}
                ${opt.address_1 ? opt.address_1 + ', ' : ''}
                ${opt.post_code ? opt.post_code + ', ' : ''}
                ${opt.city ? opt.city + ', ' : ''}
                ${opt.state ? opt.state + ', ' : ''}
              `
          };
        }),
      ];
    })
    if (this.isDanskeFragtmend) {
      await this.setDanskeData();
    }
  },
  computed: {
    ...mapGetters([
      'get_carrier_account_by_id',
      'get_carrier_account_products',
      'get_carrier_account_product_by_id',
      'get_user',
      'get_subaccounts',
      'get_carrier_account',
      'get_account_consignor',
      'get_location_shippers',
      'get_account_danske_codes',
      'get_account_danske_code_by_id',
      'get_account_danske_code_types',
      'get_account_danske_entity'
    ]),
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
    isFedExCsp() {
      return parseInt(this.accountData.integration_id) === 26;
    },
    isBackoffice1() {
      return parseInt(this.accountData.backoffice_id) === 1;
    },
    showFedExSection() {
      return this.isFedExCsp && this.isBackoffice1;
    },
    countriesOptions() {
      return this.fedexWizard.countries.map(c => ({
        value: c.alpha2,
        text: c.name
      }));
    },
    isDanskeFragtmend() {
      if (this.get_carrier_account && this.get_carrier_account.items) {
        const agentId = this.get_carrier_account.items.shipping_agent_id;
        //Danske fragtmend ID
        if (parseInt(agentId) === 12) {
          return true;
        }
      }

      return false;
    },
    haveShippingProductsForAdding() {
      return this.shippingProducts.length > 0;
    },
  },
  methods: {
    async setDanskeData() {
      await this.$store.dispatch('GET_ACCOUNT_DANSKE_CODES', {account_id: this.accountId});
      await this.getUnfilteredShippingProducts();
      const packagingsRaw = await this.$store.dispatch('GET_ALL_PACKAGING_OPTIONS');
      this.packagingOptions = [
        { value: null, text: 'None' },
        ...Object.entries(packagingsRaw).map(([id, name]) => ({ value: parseInt(id), text: name }))
      ];
      this.get_account_danske_codes.forEach((item) => {
        //This is a reactive way of filling object with data
        this.$set(this.danskeCodes, item.id, {
          id: item.id,
          consignment_type: item.consignment_type,
          shipping_type: item.shipping_type,
          shipping_product_id: item.shipping_product_id,
          packaging_id: item.packaging_id,
          types: item.types,
          code: item.code,
          code_text: `${item.consignment_type} > ${item.shipping_type} > ${item.code}`
        })

        this.$set(this.selectedDanskeTypes, item.id, item.types);
      });
    },
    getBarcodeValue(barcodeKey) {
      return this.accountData.barcode_json[0].params[barcodeKey] ?? ''
    },
    selectAccessibleSubaccount(val) {
        this.accountData.accessible_for_subaccounts = val;
    },
    routeIt() {
      this.$router.go(-1);
    },
    async getCarrierAccountProducts() {
      await this.$store.dispatch('GET_CARRIER_ACCOUNT_PRODUCTS', this.$route.params.id);
    },
    // openFedExWizard() {
    //   this.fedexWizard.step = 1;
    //   this.fedexWizard.open = true;
    //   this.fedexWizard.data.accountNumber.value = this.accountData.login_parameters_json[0].params.ShippingAccount || '';
    // },
    // fetchCountries() {
    //   axios.get('/admin/api/popup-data/get-countries').then(res => {
    //     this.fedexWizard.countries = res.data.data;
    //   }).catch(err => {
    //     console.error('Error fetching countries:', err);
    //   });
    // },
    // async validateFedExAddress() {
    //   // Trim values
    //   const data = JSON.parse(JSON.stringify(this.fedexWizard.data));
    //   data.accountNumber.value = data.accountNumber.value.trim();
    //   data.customerName = data.customerName.trim();
    //   data.address.streetLines[0] = data.address.streetLines[0].trim();
    //   data.address.city = data.address.city.trim();
    //   data.address.postalCode = data.address.postalCode.trim();
    //   data.address.countryCode = data.address.countryCode.trim();
    //   if (data.address.stateOrProvinceCode) {
    //     data.address.stateOrProvinceCode = data.address.stateOrProvinceCode.trim();
    //   }
    //
    //   this.fedexWizard.loading = true;
    //   try {
    //     const { data: res } = await this.$store.dispatch('POST_REQUEST', {
    //       url: '/popup-data/fedex-csp-validate-address',
    //       data: data
    //     });
    //     if (res.output) {
    //       this.fedexWizard.accountAuthToken = res.output.accountAuthToken;
    //       this.fedexWizard.authOptions = res.output.authenticationOptions;
    //       this.fedexWizard.step = 2;
    //       this.$store.dispatch('PUSH_MESSAGE', { type: 'success', text: this.$t('address_validated_success') });
    //     }
    //   } catch (e) {
    //     this.$store.dispatch('PUSH_MESSAGE', { type: 'error', text: e.response?.data?.message || 'Error validating address' });
    //   } finally {
    //     this.fedexWizard.loading = false;
    //   }
    // },
    // async validateFedExInvoice() {
    //   // Trim invoice values
    //   const invoiceData = {
    //     number: this.fedexWizard.invoice.number.toString().trim(),
    //     date: this.fedexWizard.invoice.date.trim(),
    //     amount: parseFloat(this.fedexWizard.invoice.amount),
    //     currency: this.fedexWizard.invoice.currency.trim()
    //   };
    //
    //   this.fedexWizard.loading = true;
    //   try {
    //     const { data: res } = await this.$store.dispatch('POST_REQUEST', {
    //       url: '/popup-data/fedex-csp-validate-invoice',
    //       data: {
    //         accountAuthToken: this.fedexWizard.accountAuthToken,
    //         invoiceDetail: invoiceData
    //       }
    //     });
    //     if (res.output && res.output.childKey) {
    //       this.saveFedExCspKeys(res.output.childKey, res.output.childSecret);
    //     }
    //   } catch (e) {
    //     this.$store.dispatch('PUSH_MESSAGE', { type: 'error', text: e.response?.data?.message || 'Error validating Invoice' });
    //   } finally {
    //     this.fedexWizard.loading = false;
    //   }
    // },
    // saveFedExCspKeys(key, secret) {
    //   this.accountData.login_parameters_json[0].params.ChildKey = key;
    //   this.accountData.login_parameters_json[0].params.ChildSecret = secret;
    //   this.accountData.login_parameters_json[0].params.ShippingAccount = this.fedexWizard.data.accountNumber.value;
    //   this.fedexWizard.step = 3;
    //   this.$store.dispatch('PUSH_MESSAGE', { type: 'success', text: this.$t('fedex_account_registered_success') });
    //   this.showSavebar = true;
    // },
    // async generateFedExPin() {
    //   this.fedexWizard.loading = true;
    //   try {
    //     await this.$store.dispatch('POST_REQUEST', {
    //       url: '/popup-data/fedex-csp-generate-pin',
    //       data: {
    //         accountAuthToken: this.fedexWizard.accountAuthToken,
    //         pinOption: this.fedexWizard.pinOption
    //       }
    //     });
    //     this.fedexWizard.step = 6;
    //   } catch (e) {
    //     this.$store.dispatch('PUSH_MESSAGE', { type: 'error', text: e.response?.data?.message || 'Error generating PIN' });
    //   } finally {
    //     this.fedexWizard.loading = false;
    //   }
    // },
    // async validateFedExPin() {
    //   this.fedexWizard.loading = true;
    //   try {
    //     const { data: res } = await this.$store.dispatch('POST_REQUEST', {
    //       url: '/popup-data/fedex-csp-validate-pin',
    //       data: {
    //         accountAuthToken: this.fedexWizard.accountAuthToken,
    //         pin: this.fedexWizard.pin.trim()
    //       }
    //     });
    //     if (res.output && res.output.childKey) {
    //       this.saveFedExCspKeys(res.output.childKey, res.output.childSecret);
    //     }
    //   } catch (e) {
    //     this.$store.dispatch('PUSH_MESSAGE', { type: 'error', text: e.response?.data?.message || 'Error validating PIN' });
    //   } finally {
    //     this.fedexWizard.loading = false;
    //   }
    // },
    deleteAgreement() {
      this.$store.dispatch('DELETE_CARRIER_ACCOUNT_BY_ID', this.$route.params.id).then(() => {
        this.$router.push('/settings/shipping/agreements');
      });
    },
    async getCarrierAccountAndSetData() {
      await this.$store.dispatch('GET_CARRIER_ACCOUNT', {id: this.accountId}).then((res) => {
        this.accountData.countries = res.items.countries;
        this.accountData.accessible_for_subaccounts = res.items.accessible_for_subaccounts;
        this.accountData.integration_name = res.items.integration_name;
        this.accountData.shipping_agent_id = res.items.shipping_agent_id;
        this.accountData.account_name = res.items.account_name;
        this.accountData.barcode_json = res.items.barcode_json;
        this.accountData.is_active = res.items.is_active;
        this.accountData.integration_type = res.items.integration_type;
        this.accountData.integration_id = res.items.integration_id;
        this.accountData.backoffice_id = res.items.backoffice_id;
        this.accountData.should_create_sales_orders = res.items.should_create_sales_orders;
        this.accountData.should_send_customs_file = res.items.should_send_customs_file;
        this.accountData.have_proactive_support = res.items.have_proactive_support;
        this.accountData.company_id = res.items.company_id;
        this.accountData.display_account_name = res.items.display_account_name;
        this.accountData.shipping_agent_name = res.items.shipping_agent_name;
        this.accountData.integration_params_fields = res.items.integration_params_fields;

        // Login params
        this.accountData.login_parameters_json[0].params = {...res.items.login_parameters_json[0].params};

        // Barcode fields
        this.barcodeViewHelper = res.items.integration_params_fields[0].barcode_view_helper;
        this.$nextTick(() => {
          this.savebarEnabled = true;
        })
      })
    },
    async getConsignnes() {
      await this.$store.dispatch('GET_ACCOUNT_CONSIGNOR',  this.$route.params.id
      ).then((res) => {
        this.consignors = [];
        Object.values(res).forEach(value => {
          value.forEach((item) => {
            this.consignors.push({
                  value: item.consignor_id,
                  text: `
                ${item.sender_company_name ? item.sender_company_name + ', ' : ''}
                ${item.sender_name ? item.sender_name + ', ' : ''}
                ${item.sender_address_1 ? item.sender_address_1 + ', ' : ''}
                ${item.sender_post_code ? item.sender_post_code + ', ' : ''}
                ${item.sender_city ? item.sender_city + ', ' : ''}
                ${item.sender_state ? item.sender_state + ', ' : ''}
              `,
              consignors_id: item.id
            });
          });
        });
      });
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    compareProducts(compare, array) {
      let result = false;
      array.forEach((item) => {
        if(item.shipping_product_id == compare){
          result = true;
        }
      });
      return result;
    },
    changeAccountData() {
      this.accountData.accessible_for_subaccounts = this.accountData.accessible_for_subaccounts.filter((val) => this.get_user.accessible_subaccounts_array.indexOf(String(val)) > -1);
      this.accountData.barcode_json[0].params[this.activeLastMin] = this.accountData.barcode_json[0].params[this.activeMin];
      this.accountData.barcode_json[0].params[this.activeLastMax] = this.accountData.barcode_json[0].params[this.activeMax];
      this.accountData.barcode_json[0].params[this.activeMin] = this.minValue;
      this.accountData.barcode_json[0].params[this.activeMax] = this.maxValue;

      this.$store.dispatch('EDIT_CARRIER_ACCOUNT', {
        id: this.$route.params.id,
        form: {
          countries: this.accountData.countries,
          accessible_for_subaccounts: this.accountData.accessible_for_subaccounts,
          is_active: Number(this.accountData.is_active),
          account_name: this.accountData.account_name,
          integration_id: this.accountData.integration_id,
          company_id: this.get_user.company_id,
          integration_type: 2,
          shipping_agent_id: this.accountData.shipping_agent_id,
          have_proactive_support: 0,
          should_create_sales_orders: 0,
          should_send_customs_file: this.accountData.should_send_customs_file,
          barcode_json: this.accountData.barcode_json,
          login_parameters_json: this.accountData.login_parameters_json,
        },
      }).then(() => {
        this.getCarrierAccountAndSetData().then(() => {
          this.showSavebar = false;
        })
      });
    },
    async submitForm() {
      if( this.addProductPopup ) {
        await this.asyncForEach(this.selectedProducts, async (id) => {
          await this.$store.dispatch('SET_CARRIER_ACCOUNT_PRODUCTS', {
            shipping_product_id: id,
            admin_carrier_account_id: this.$route.params.id,
          });
        });
        this.getCarrierAccountProducts().then(() => {
          this.getShippingProducts();
        });
        this.selectedProducts = [];
      } else if(this.editBarcodesPopup) {
        this.changeAccountData();
      }
      this.togglePopup();
    },
    submitNoteForm() {
      this.$store.dispatch('EDIT_CARRIER_ACCOUNT_PRODUCTS', {
        payload: this.noteForm,
        id: this.editNoteId
      }).then(() => {
        this.$store.dispatch('GET_CARRIER_ACCOUNT_PRODUCTS', this.$route.params.id).then(() => {
          this.getShippingProducts();
        });
      });
      this.clearNoteFormData()
      this.toggleNotePopup()
    },
    updateDanskeCode(val, i, prop) {
      this.danskeCodes[i][prop] = val;
      const data = this.danskeCodes[i];
      let payload = {
        data: data,
        account_id: this.$route.params.id,
        id: data.id
      };

      this.$store.dispatch('EDIT_ACCOUNT_DANSKE_CODE', payload);
    },
    async submitConsignorForm() {
          await this.$store.dispatch('SET_ACCOUNT_CONSIGNOR', {
              sender_id: this.consignorForm.senderId,
              account_id: this.$route.params.id,
              consignor_id: this.consignorForm.consignorId
          });
        await this.getConsignnes();
        this.toggleConsignorPopup();
        this.clearLocalFormData();
    },
    selectShippingProduct(val) {
      this.selectedProducts = val;
    },
    selectDanskeType(val, i, prop) {
      this.selectedDanskeTypes[i] = val;
      this.updateDanskeCode(val, i, prop)
    },
    getShippingProducts() {
      this.$store.dispatch('GET_SHIPPING_PRODUCTS', {agentId: this.accountData.shipping_agent_id, type: 1}).then((res) => {
        this.shippingProducts = [];
        res.forEach((item) => {
          if (!this.compareProducts(item.shipping_product_id, this.get_carrier_account_products) ){
            this.shippingProducts.push({
              text: item.product_name,
              value: item.shipping_product_id.toString(),
            });
          }
        });
      });
    },
    getUnfilteredShippingProducts() {
      this.$store.dispatch('GET_SHIPPING_PRODUCTS', {agentId: this.accountData.shipping_agent_id}).then((res) => {
        this.unfilteredShippingProducts = [];
        res.forEach((item) => {
          this.unfilteredShippingProducts.push({
            text: item.product_name,
            value: item.shipping_product_id,
          });
        });
      });
    },
    addProduct() {
      this.togglePopup();
      this.addProductPopup = true;
      this.getShippingProducts();
    },
    getDanskeConfiguration() {
      this.$store.dispatch('GET_ACCOUNT_DANSKE_CONFIGURATIONS', this.$route.params.id).then(() => {
        this.setDanskeData();
      })
    },
    addConsignor() {
      this.toggleConsignorPopup();
      this.addConsignorPopup = true;
      this.getConsignnes();
    },
    deleteProduct(id) {
      this.$store.dispatch('DELETE_CARRIER_ACCOUNT_PRODUCTS', id).then(() => {
        this.$store.dispatch('GET_CARRIER_ACCOUNT_PRODUCTS', this.$route.params.id).then(() => {
          this.getShippingProducts();
        });
      });
    },
    deleteConsignor(id) {
      this.$store.dispatch('DELETE_ACCOUNT_CONSIGNOR', id).then(() => {
        this.$store.dispatch('GET_ACCOUNT_CONSIGNOR', this.$route.params.id).then(() => {
          this.getConsignnes();
        });
      });
    },
    editBarcode(val) {
      this.togglePopup();
      this.editBarcodesPopup = true;
      this.activeMin = val[0].key;
      this.activeMax = val[1].key;
      this.activeLastMin = val[2].key;
      this.activeLastMax = val[3].key;
      this.minValue = this.accountData.barcode_json[0].params[this.activeMin];
      this.maxValue = this.accountData.barcode_json[0].params[this.activeMax];
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.addProductPopup = false;
      this.addConsignorPopup = false;
      this.editBarcodesPopup = false;
      this.activeMin = '';
      this.activeMax = '';
      this.activeLastMin = '';
      this.activeLastMax = '';
      this.minValue = '';
      this.maxValue = '';
    },
    toggleConsignorPopup() {
      this.openConsignorPopup= !this.openConsignorPopup;
      this.addConsignorPopup = false;
      this.clearLocalFormData();
    },
    toggleNotePopup(id) {
      this.openNotePopup= !this.openNotePopup;
      const data = this.get_carrier_account_product_by_id(id);
      if (!data) {
        return;
      }

      this.editNoteId = id
      this.noteForm = {
        shipping_product_id: data.shipping_product_id,
        admin_carrier_account_id: this.$route.params.id,
        note: data.note
      };
      this.clearNoteFormData
    },
    clearNoteFormData() {
      this.editNoteId = ''
      this.noteForm = {
        shipping_product_id: '',
        admin_carrier_account_id: '',
        note: ''
      };
    },
    clearLocalFormData() {
      this.consignorForm = {
        shippers: [],
        consignorId: '',
      };
    },
    cancel() {
      this.showSavebar = false;
    },
    saveChanges() {
      this.showSavebar = false;
    },
    selectCountries(val) {
      this.accountData.countries = val;
    },
  },
  watch: {
    'accountData.countries': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'accountData.accessible_for_subaccounts': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'accountData.account_name': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'accountData.is_active': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'accountData.should_send_customs_file': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'accountData.login_parameters_json': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
  },
};
</script>
